'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
/**
 * @class FinderActionsDropdown
 */

class FinderActionsDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOpenChange = this.handleOpenChange.bind(this);
    this.state = {
      open: props.open
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.open !== prevState.open) {
      this.setState({
        open: this.props.open
      });
    }
  }

  handleOpenChange(evt) {
    if (this.props.onOpenChange) {
      this.props.onOpenChange(evt);
      return;
    }

    this.setState({
      open: evt.target.value
    });
  }

  render() {
    const _this$props = this.props,
          {
      children
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    const {
      open
    } = this.state;
    return /*#__PURE__*/_jsx(UIDropdown, Object.assign({}, rest, {
      buttonUse: "link",
      onOpenChange: this.handleOpenChange,
      open: open,
      placement: "bottom right",
      responsive: false,
      children: children
    }));
  }

}
/**
 * Statics
 */


FinderActionsDropdown.propTypes = {
  children: PropTypes.node,
  onOpenChange: PropTypes.func,
  open: PropTypes.bool
};
FinderActionsDropdown.defaultProps = {
  children: null,
  onOpenChange: null,
  open: false
};
/**
 * Export
 */

export default FinderActionsDropdown;